import * as React from "preact";
import { FunctionComponent } from "preact";
import cx from "classnames";

export interface ILoading {
  text?: string;
  className?: string;
  center?: boolean;
  centerHorizontally?: boolean;
  pad?: boolean;
  overlay?: boolean;
}

const Loading: FunctionComponent<ILoading> = ({
  className,
  text,
  center = true,
  centerHorizontally = false,
  pad = false,
  overlay = false,
}) => (
  <div className={cx("js-loading", className)}>
    {text || "Loading..."}
    <div
      className={cx(
        "loading-indicator",
        { "loading-indicator--center": center },
        { "loading-indicator--center-horizontally": centerHorizontally },
        { "loading-indicator--pad": pad },
        { "loading-indicator--overlay": overlay }
      )}
    ></div>
  </div>
);

export default Loading;
